
import { sendError } from '@/helpers/sentry';
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import PreviewJobBody from '@/components/jobDetailed/previewJob/PreviewJobBody.vue';
import { getDetailedJobById } from '@/api';
// import { JobDetailedData } from '@/models/jobDetailed';
import { components } from '@/models/jobDetailed';
type JobDetailedData = components['schemas']['Job'];

@Component({
  components: {
    PreviewJobBody,
  },
})
export default class PreviewJobLoadBody extends Vue {
  @Prop(Number) public jobId: number;
  @Prop(Boolean) public isShow: boolean;

  public loading = false;
  public job: JobDetailedData | null = null;

  @Watch('isShow', { immediate: true })
  private watchIsShow(isShow: boolean) {
    if (isShow) {
      this.fetchDataById(this.jobId);
    }
  }

  private fetchDataById(id: number): void {
    this.loading = true;
    this.job = null;
    getDetailedJobById(id)
      .then((job: JobDetailedData) => {
        this.job = job;
        this.$emit('loaded', job);
      })
      .catch(err => {
        sendError(err, 'PreviewJobLoadBody');
      })
      .finally(() => {
        this.loading = false;
      });
  }
}
